<template>
    <div class="img-picker-loading">
        <v-spinner
            status="default"
            size="large"
        />
    </div>
</template>

<script>
export default {
    name: 'ReplyLoading',
};
</script>

<style scoped>
.img-picker-loading {
    position: absolute;
    top: 40%;
    left: 0;
    right: 0;
    text-align: center;
}
</style>
